import { AlertCircleIcon } from "@hugeicons-pro/core-solid-rounded";
import { HugeiconsIcon } from "@hugeicons/react";

export const InvalidData = ({ text }: { text: string }) => (
  <p className="text-danger-500 font-medium text-sm flex items-center gap-1">
    <HugeiconsIcon
      icon={AlertCircleIcon}
      size={16}
      className="text-danger-500"
    />
    {text}
  </p>
);
